import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UnbilledItemsPageStatuses = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const
export type UnbilledItemsPageStatusEnum = Enum<typeof UnbilledItemsPageStatuses>

export interface UnbilledItemsPageParams {
  status: UnbilledItemsPageStatusEnum | ''
}

export interface BillApprovalsPageParams {
  status: string
}

export const UnbilledExpenseItemsPageStatuses = {
  PENDING: 'pending',
  REIMBURSE: 'reimburse',
  ARCHIVED: 'archived',
} as const
export type UnbilledExpenseItemsPageStatusEnum = Enum<
  typeof UnbilledExpenseItemsPageStatuses
>

export interface UnbilledExpenseItemsPageParams {
  status: UnbilledExpenseItemsPageStatusEnum | ''
}

export const AccountDetailsPageTabs = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
} as const
export type AccountDetailsPageTabEnum = Enum<typeof AccountDetailsPageTabs>

export interface CreditCardAccountDetailsPageParams {
  id: string
  tab: AccountDetailsPageTabEnum
}

export const MatchPageTabs = {
  UNMATCHED: 'unmatched',
  MATCHED: 'matched',
} as const
export type MatchPageTabEnum = Enum<typeof MatchPageTabs>

export interface ReconciliationMatchPageParams {
  id: string
  tab: MatchPageTabEnum
}

export interface CreateCreditCardBillPageParams {
  id: string
}
